<div class="flex w-full h-full">
  <ng-container *ngIf="filtersLoadingState$ | async as filtersLoadingState">
    <div class="flex flex-col w-full">
      <div class="flex flex-row mb-4 w-full">
        <div
          class="grid grid-cols-3 justify-items-start sbnbDesktop:flex sbnbDesktop:flex-grow"
          *ngIf="appliedFilters$ | async as appliedFilters">
          <hospitable-filters
            class="col-span-3 col-start-1"
            *ngIf="filtersLoadingState === LoadingState.Success"
            [filters]="filters$ | async"
            [appliedFilters]="appliedFilters$ | async"
            (addFilter)="onAddFilter($event)"
            (applyFilter)="onApplyFilter($event)"
            (removeFilter)="onRemoveFilter($event)"
            (clearAllFilters)="onClearAllFilters()"></hospitable-filters>

          <hospitable-loading *ngIf="filtersLoadingState === LoadingState.Pending"></hospitable-loading>

          <hospitable-save-view
            [metricKey]="MetricKey.Reservations"
            [appliedFilters]="appliedFilters"></hospitable-save-view>

          <ng-container *ngIf="views$ | async as views">
            <button
              *ngIf="views && views.length > 0"
              (click)="openListViewDialog(views)"
              mat-flat-button
              class="button__small button__text button_add-filter raspberry-darker">
              <span *ngIf="(activeView$ | async) === null">Views</span>

              <span class="flex" *ngIf="activeView$ | async as activeView">
                {{ activeView.name }}

                <span (click)="clearActiveView($event)">
                  <img class="filter__clearable" src="./assets/icons/cancel-smoke.svg" onload="SVGInject(this)" />
                </span>
              </span>
            </button>
          </ng-container>
        </div>

        <div class="flex flex-row-reverse min-w-fit">
          <sbnb-button
            *ngIf="appliedFilters$ | async as appliedFilters"
            label="Export"
            size="mini"
            (clicked)="export(appliedFilters)"></sbnb-button>
        </div>
      </div>

      <div class="flex flex-col">
        <ng-container [ngSwitch]="pageLoadingState$ | async">
          <ng-container *ngSwitchCase="LoadingState.Pending">
            <div class="m-auto">
              <div class="flex h-full">
                <hospitable-loading></hospitable-loading>
              </div>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="LoadingState.Success">
            <ng-container *ngIf="dataTooLarge$ | async">
              <div class="flex flex-col w-full items-center justify-center mt-8">
                <hospitable-page-level-error
                  [message]="'Data too large. Please adjust your filters.'"></hospitable-page-level-error>
              </div>
            </ng-container>
            <div class="flex flex-col w-full">
              <ng-container *ngIf="(dataTooLarge$ | async) === false">
                <ng-container *ngIf="statistics$ | async as statistics">
                  <div *ngIf="statistics && statistics.length > 0" class="grid grid-cols-2 lg:grid-cols-5 mt-6 mb-6">
                    <div *ngFor="let statistic of statistics">
                      <hospitable-metrics-widget
                        [title]="statistic.title"
                        [tooltip]="statistic.tooltip"
                        [value]="statistic.value"
                        [changeInValue]="statistic.difference ? statistic.difference + '%' : null"
                        [changeInValueColour]="statistic.difference > 0 ? MetricColour.Positive : MetricColour.Negative"
                        [badgeTooltip]="statistic.badge_tooltip"></hospitable-metrics-widget>
                    </div>
                  </div>
                </ng-container>
              </ng-container>

              <div class="flex w-full">
                <mat-tab-group class="w-full">
                  <mat-tab [label]="'Charts'">
                    <ng-container *ngIf="(dataTooLarge$ | async) === false">
                      <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6" *ngIf="graphs$ | async as graphs">
                        <div *ngFor="let graph of graphs">
                          <hospitable-donut-chart [chart]="graph"></hospitable-donut-chart>
                        </div>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="(dataTooLarge$ | async) === true">
                      <div class="flex items-center justify-center mt-8">
                        <hospitable-page-level-error
                          [message]="'Data too large. Please adjust your filters.'"></hospitable-page-level-error>
                      </div>
                    </ng-container>
                  </mat-tab>

                  <mat-tab class="w-full" [label]="'Details'">
                    <ng-container [ngSwitch]="detailsLoadingState$ | async">
                      <ng-container *ngSwitchCase="LoadingState.Pending">
                        <div class="flex items-center justify-center mt-8">
                          <hospitable-loading></hospitable-loading>
                        </div>
                      </ng-container>

                      <ng-container *ngSwitchCase="LoadingState.Success">
                        <ng-container *ngIf="details$ | async as details; else noData">
                          <hospitable-table
                            *ngIf="appliedFilters$ | async as appliedFilters"
                            class="mb-4"
                            [data]="details"
                            (pageChanged)="onDetailsPageChange($event, appliedFilters)"></hospitable-table>
                        </ng-container>

                        <ng-template #noData>
                          <div class="flex items-center justify-center mt-8">
                            <hospitable-page-level-error [message]="'No data found'"></hospitable-page-level-error>
                          </div>
                        </ng-template>
                      </ng-container>

                      <ng-container *ngSwitchCase="LoadingState.Error">
                        <div class="flex items-center justify-center mt-8">
                          <div class="flex">
                            <hospitable-page-level-error></hospitable-page-level-error>
                          </div>
                        </div>
                      </ng-container>
                    </ng-container>
                  </mat-tab>
                </mat-tab-group>
              </div>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="LoadingState.Error">
            <div class="m-auto">
              <div class="flex h-full">
                <hospitable-page-level-error></hospitable-page-level-error>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </ng-container>
</div>
